//@ts-nocheck
import { applySnapshot, getSnapshot, types } from "mobx-state-tree";

export const PaymentInfoStore = types
  .model("PaymentInfoStore", {
    paymentMethod: types.optional(types.string, "Bank Transfer"),
    bankName: types.optional(types.string, ""),
    accountName: types.optional(types.string, ""),
    accountNumber: types.optional(types.string, ""),
    sortCode: types.optional(types.string, ""),
    taxId: types.optional(types.string, ""),
    banks: types.optional(types.array(types.string), []),
  })
  .views((self) => {
    return {
      get formValues(): {
        bankName: string;
        accountName: string;
        accountNumber: string;
        sortCode: string;
        paymentMethod: string;
        taxId: string;
      } {
        return {
          paymentMethod: self.paymentMethod,
          sortCode: self.sortCode,
          bankName: self.bankName,
          accountName: self.accountName,
          accountNumber: self.accountNumber,
          taxId: self.taxId,
        };
      },
      get completed() {
        return Boolean(self.bankName && self.accountName && self.accountNumber);
      },
    };
  })
  .actions((self) => {
    const onFormSubmit = function onFormSubmit(formData: any) {
      let xx: any = getSnapshot(self);
      applySnapshot(self, { ...xx, ...formData });
    };

    return {
      onFormSubmit,
      initializeBanksInfo(banksData) {
        self.banks = banksData;
      },
      updateFields(values: {
        bankName: string;
        accountName: string;
        accountNumber: string;
      }) {
        const oldValues: {
          bankName: string;
          accountName: string;
          accountNumber: string;
        } = getSnapshot(self);
        applySnapshot(self, { ...oldValues, ...values });
      },
    };
  });
